import { Col, Row, Tabs } from 'antd';
import { useIntl } from 'react-intl';
import type { TabsProps } from 'antd';
import languageData from '../../../../../../domain/core/AppLanguageSwitcher/data';
import LanguageCode from '../../../../../../shared/services/types/language-code';
import AttributeInfoStandard from './attribute-info-standard';
import AttributeInfoLanguage from './attribute-info-language';
import MainUtils from 'src/shared/utils/main';
import { useLocaleContext } from 'src/domain/utility/AppContextProvider/LocaleContextProvide';

interface IAttributeInfoProps {
  categoriesList?: any;
  setIsAvailableAllCategories?: any;
  categoryLoading?: boolean;
}

const AttributeInfo = (props: IAttributeInfoProps) => {
  const { categoriesList, setIsAvailableAllCategories, categoryLoading } = props;

  const { messages } = useIntl();

  const { locale }: any = useLocaleContext();

  const langComponent = [
    {
      code: `${LanguageCode.English}`,
      langComponent: <AttributeInfoLanguage code={LanguageCode.English} />,
    },
    {
      code: `${LanguageCode.Español}`,
      langComponent: <AttributeInfoLanguage code={LanguageCode.Español} />,
    },
    {
      code: `${LanguageCode.Arabic}`,
      langComponent: <AttributeInfoLanguage code={LanguageCode.Arabic} />,
    },
  ];

  const itemsTab: TabsProps['items'] = [
    {
      key: 'standard',
      label: `${messages[
        'specificationAttributes.specificationAttributesInfo.standard'
      ].toString()}`,
      children: (
        <AttributeInfoStandard
          categoryLoading={categoryLoading}
          categoriesList={categoriesList}
          setIsAvailableAllCategories={setIsAvailableAllCategories}
          code={`${!MainUtils.isEmptyValue(locale.code)
              ? locale.code
              : LanguageCode.English
            }`}
        />
      ),
    },
    ...languageData
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((language) => {
        return {
          key: language.code,
          label: (
            <>
              <Row gutter={7}>
                <Col>
                  <i className={`flag flag-24 flag-${language.icon}`} />
                </Col>
                <Col>
                  <h4 className='title-tab'>{language.name}</h4>
                </Col>
              </Row>
            </>
          ),
          children: (
            <>
              {langComponent && langComponent?.length > 0 ? (
                langComponent?.find((item) => item.code === language.code)
                  ?.langComponent ?? <></>
              ) : (
                <></>
              )}
            </>
          ),
        };
      }),
  ];
  return <Tabs defaultActiveKey='standard' items={itemsTab} />;
};

export default AttributeInfo;
